export const SET_HOTEL_CATEGORY = 'ROOMLIST/SET_HOTEL_CATEGORY'
export const SET_HOTEL_CATEGORIES = 'ROOMLIST/SET_HOTEL_CATEGORIES'
